import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function ModalClose({
    onClick
}: Readonly<{
    onClick: () => void
}>) {
    return (
        <IconButton aria-label="close" onClick={onClick}>
            <CloseIcon />
        </IconButton>
    );
}